/* ==========================================================================
   CounterRxjs > Client > UI
   ========================================================================== */

/* Modules */

/* Update UI */
function updateUI(value, instance) {
    const { min, max } = instance.config;
    const { increment, decrement } = instance;
    const valueEl = instance.hooks.value;

    /* Clear first */
    [increment, decrement].forEach(item => item.actions.enable());

    /* Min */
    if (value === min) {
        decrement.actions.disable();
    }

    /* Max */
    if (value === max) {
        increment.actions.disable();
    }

    /* Set Value to UI */
    if (!(value < min || value > max)) {
        valueEl.innerText = value;
    }
}

/* Exports */
module.exports = {
    updateUI
};
